import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Logger } from 'src/app/@shared';

const log = new Logger('ProductTabsComponent');
@Component({
  selector: 'app-product-brand-tabs',
  templateUrl: './product-brand-tabs.component.html',
  styleUrls: ['./product-brand-tabs.component.scss']
})
export class ProductBrandTabsComponent implements OnInit {

  brandId = '0';

  constructor(private route: ActivatedRoute,) { }

  ngOnInit(): void {
    log.debug('init');
    // get the product id from the route params
    this.brandId = this.route.snapshot.params['brandId'];
  }

}
